import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useEffect, useRef } from "react";
import Modal from "../components/modules/modal";
import SliderRelated from "./slider-related";

const CartModal = ({
  show,
  onHide,
  msg,
  msgKey,
  icon = "tick",
  cartUrl,
  loading,
  sliderProducts,
  productId,
}) => {
  const ref = useRef(null);

  const { labelManagerLabels, sliderProductsAC } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        goToCart
        continueOnTheShop
        anErrorAsOccurred
        itemAddedToCart
        noProductsInCart
        relatedProducts
        cartModalRelatedProducts
      }
      sliderProductsAC: liferayPageLine(lineId: { eq: "333" }) {
        lineId
        allBabelProdotto {
          key_prod
          related {
            assetId
            key_prod
            productName
            productLink
            minicard4
            productDescBefore
            productDescAfter
            productTitleNoFamilyAC
            energyClass
            energyLabelCav
            pageLine {
              slug
              lineId
              pageName
              docConfiguration
              liferayFields {
                taxonomyCategoryBriefs {
                  name
                  liferayId
                }
              }
            }
            lineId
            id
            brand_id
            brandName
            productName
            primaryimage {
              imageType
              imageUrl
              gatsbyImageData(width: 500)
            }
            productApp {
              ...ProductAppAppFragment
            }
            triples {
              keySellingPoint
            }
            connectivity
            connectivityActive
            productMsrpPrice
            productSellingPrice
            productOmnibusPrice
            shopLink
            productTags {
              ...ProductTagFragment
            }
            notificationEcommerce {
              ...NotificationEcommerceFragment
            }
          }
        }
      }
    }
  `);

  const sliderProductsACFiltered = sliderProductsAC?.allBabelProdotto?.find(
    (product) => product.key_prod === productId
  );
  const sliderProductsFiltered =
    sliderProductsAC?.lineId === "333" ? sliderProductsACFiltered?.related : sliderProducts;

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`cart-modal${show ? " cart-modal--show" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        role="dialog"
        aria-hidden={!show || !cartUrl}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        onKeyDown={onKeyDown}
      >
        {loading ? (
          <div className="cart-modal__loading"></div>
        ) : (
          <div className="modal cart-preview-modal visible" id="cart-preview-modal">
            <span className="modal-backdrop close-modal"></span>
            <div className="modal-content">
              <div className="modal-body">
                <div className="cart-preview-modal__message">
                  {icon ? (
                    <div className={`cart-modal__icon cart-modal__icon--${icon}`}>
                      <span className={`icon-${icon}`}></span>
                    </div>
                  ) : null}
                  <h3>{msgKey && labelManagerLabels[msgKey] ? labelManagerLabels[msgKey] : msg}</h3>
                  <div className="btns">
                    {cartUrl ? (
                      <div className="cart-modal__cta">
                        <a href={cartUrl} className="cart-modal__close button primary blue">
                          {labelManagerLabels.goToCart}
                        </a>
                      </div>
                    ) : null}
                    <button className="cart-modal__close button primary white" onClick={onHide}>
                      {labelManagerLabels.continueOnTheShop}
                    </button>
                  </div>
                </div>
                {sliderProductsFiltered?.length ? (
                  <SliderRelated
                    data={sliderProductsFiltered}
                    labelManagerLabels={labelManagerLabels}
                    isCartModal
                    onHide={onHide}
                  />
                ) : null}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CartModal;
